import { gql } from "@apollo/client";
const GETENTRIESCOUNT = gql`
query registrationCount($tournament:Int) {
    registrationCount(tournament: $tournament)
}
`;
export default GETENTRIESCOUNT;